
export default function PageNotFoundPage()
{
	return (
		<div>
			<p>Page not found</p>
			<br/>
			<p><a href='/admin'>Return to the top page</a></p>
		</div>
	);
}

